import React from "react";
import { graphql } from "gatsby";
import GraphQLErrorList from "../components/graphql-error-list";
import Seo from "../components/seo";
import Layout from "../containers/layout";
import PageHeader from "../components/page-header";
import FlexibleContent from "../components/flexible-content";
import Updates from "../components/fc-updates";

const UpdateTemplate: React.FC<PageProps<any>> = ({ data, errors }) => {
  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
      </Layout>
    );
  }

  const update = data?.update;
  if (!update.slug || !update.slug.current) return null;

  return (
    <Layout>
      <PageHeader
        title={update?.title}
        image={update?.featuredImage}
        date={update?.publicationDate}
        updateCategory={update?.category}
      />
      <FlexibleContent items={update?.flexibleContent} />
      <Updates updates={update?.updates} title="Related Updates" />
    </Layout>
  );
};

export default UpdateTemplate;

export const Head: React.FC<{ data: any }> = ({ data }) => {
  const update = data?.update;

  return (
    <Seo
      title={update?.title}
      description={update?.seo?.description}
      image={update?.seo?.thumbnail}
    />
  );
};

export const query = graphql`
  query UpdateTemplateQuery($id: String!) {
    update: sanityUpdate(id: { eq: $id }) {
      slug {
        current
      }
      id
      title
      publicationDate
      category {
        title
        slug {
          current
        }
      }
      featuredImage {
        desktop {
          asset {
            _id
          }
          alt
        }
        mobile {
          asset {
            _id
          }
        }
      }
      flexibleContent {
        ... on SanityFcCopyBlockPage {
          _key
          _type
          _rawCopy
        }
        ... on SanityFcVideoPage {
          _key
          _type
          url
          thumbnail {
            asset {
              _id
            }
            alt
            _rawCaption
          }
        }
        ... on SanityFcImages {
          _key
          _type
          images {
            _key
            image {
              asset {
                _id
              }
              alt
              _rawCaption
            }
            sizeLarge
          }
        }
      }
      updates {
        _key
        update {
          title
          slug {
            current
          }
          category {
            title
            slug {
              current
            }
          }
          lp {
            image {
              asset {
                _id
              }
              alt
            }
          }
        }
      }
      seo {
        description
        thumbnail {
          asset {
            _id
          }
          alt
        }
      }
    }
  }
`;
